import { CSSProperties } from 'react'

export const s = {
  root: {
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  notification: {
    body: {
      width: 380,
    } as CSSProperties,
    text: { fontSize: 24 } as CSSProperties,
  },
  dateTime: {
    color: '#595959',
    fontSize: 24,
    marginBottom: 42,
  },
  button: {
    marginLeft: 'auto',
    backgroundColor: 'transparent',
  } as CSSProperties,
}
